import { CSSObject } from '@chakra-ui/react';

export const TextFormInfo: CSSObject = {
  color: 'beta.400',
  fontWeight: 'medium',
};
